import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";

export const gq_callLogs = gql`
  query getCallLogs($pin: Int!, $filterBy: [JSONString], $offset: Int = 0, $pageSize: Int = 10, $sort: [JSONString]) {
    callLogs(pin: $pin, offset: $offset, filterBy: $filterBy, pageSize: $pageSize, sort: $sort) {
      callLogs{
        message
        step
        dtmf
        timeStamp
        cid
      }
      pages
    }
  }
`

export const gq_getProject = gql`
  query project($pid: Int) {
    project(pid: $pid) {
      name
    }
  }
`

export const gq_pinLogs = gql`
  query getPinLogs($filterBy: [JSONString], $offset: Int = 0, $pageSize: Int = 10, $sort: [JSONString], $view: String, $pid: Int) {
    pinLogs(filterBy: $filterBy, offset: $offset, pageSize: $pageSize, sort: $sort, view: $view, pid: $pid) {
      pinlogs {
        pin
        pid
        part
        callStart
        callDuration
        message
        speakeridInline
        speakeridOutline
        demographicInline
        demographicOutline
        phonenumberInline
        phonenumberOutline
        speakerInline {
          speakerId
          phonenumber
          spkrPk
        }
        speakerOutline {
          speakerId
          phonenumber
          spkrPk
        }
        pin1 {
          conversational {
            edges {
              node {
                currentRecordingLength
                maxRecordingLength
                scheduledConference {
                  starttime
                  endtime
                }
              }
            }
          }
          user {
            username
          }
        }
      }
      pages
    }
  }
`

export const getPinLogsQuery = compose(
  graphql(gq_pinLogs,{
    name: "PinLogs"
  }),
  graphql(gq_getProject, {
    name: "Project",
    options: (props) => ({
      variables: {
        pid: props.match.params.id
      },
      fetchPolicy: "cache-and-network",
      errorPolicy: "all"
    })
  })
);

export const getCallLogsQuery = compose(
  graphql(gq_callLogs,{
    options: (props) => ({
      variables: {
        pin: props.match.params.id
      },
      errorPolicy: "all",
      fetchPolicy: 'cache-and-network'
    }),
    name: "getCallLogsQuery"
  })
);

/* pin assign to user query and grapqhl statements */

export const getPinCount = gql`
  query getPinCount($pid:Int!){
    getPinCount(pid:$pid){
      count
    }
  }
`
export const getUsersByPid = gql`
  query getUsersByPid($pid:Int!){
    project (pid:$pid) {
      users {
        edges {
          node {
            username
            uid
            active
          }
        }
      }
    }
  }
`
export const assignPinsToUsers = gql`
  mutation assignPins($inputJson:String!) {
    assignPins(inputJson:$inputJson) {
      jsonObject
    }
  }
`
export const pinAssign = compose(
    graphql(getPinCount, {
      options: (props)=> ({
              variables: {
                  pid:props.projectId
              },
              errorPolicy: "all",
              fetchPolicy: 'network-only'
      }),
      name: "getPinCount"
    }),
    graphql(getUsersByPid, {
      options: (props)=> ({
              variables: {
                  pid:props.projectId
              },
              errorPolicy: "all",
              fetchPolicy: 'cache-and-network'
      }),
      name: "getUsersByPid"
    }),
    graphql(assignPinsToUsers, {
      options: {
        errorPolicy: "all",
      },
      name: "assignPins"
    })
);
/* end of pin assign queries and grapqhl statements*/


// WEBPACK FOOTER //
// ./src/views/pin/graph.js